//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */ 
// @author Rico
import { mapState } from "vuex";
import Storage from "@/utils/storage";
import { captchas } from "@/api/account";
import { applyAgent, getIncome ,updateBank} from "@/api/agent";
import { isPhone } from "@/utils/is";
import {  Message, MessageBox } from "apower-ui";

Vue.prototype.$message = Message;
Vue.prototype.$messageBox = MessageBox;

export default {
  name: "App",
  data() {
    const telephoneValidator = (rule, value, callback) => {
      if (!this.form.telephone) {
        callback(new Error("请输入手机号"));
      } else if (!isPhone(this.form.telephone)) {
        callback(new Error("请输入正确的手机号"));
      } else {
        callback();
      }
    };
    return {
      loading:false,
      mainRoute: "apply", // 主路由,可选值 apply,profit
      phoneTimeout: 0,
      phoneIntervalId: null,
      timeoutWait: 60,
      errorMessage: null,
      telephoneValidator: null,
      currentPage: 1,
      page: 1,
      limit: 10,
      start_time: "",
      end_time: "",
      list: [],
      total: null,
      total_amount: null,
      share_amount: null,
      share_amount_complete: null,
      share_amount_wait: null,

      form: {
        name: "",
        telephone: "",
        captcha: "",
        email: "",
        wechat: "",
        company: "",
        address: "",
        how_learn: "",
        like_product: "",
        how_extend: "",
        extension_channel: "",
        channel_link: "",
        mark: "",
      },
      selectLength: 0,//全选

      like_product: [
      {
          label: "",
          options: [
            {
              value: "全选"
            },
          ]
      },
        {
          label: "多媒体",
          options: [
            {
              value: "傲软无限包"
            },
            {
              value: "视频编辑王"
            },
            {
              value: "压缩宝"
            },
            {
              value: "ApowerShow"
            },
            {
              value: "录音精灵"
            },
            {
              value: "视频转换王"
            },
            {
              value: "水印管家"
            },
            {
              value: "傲软GIF"
            }
          ]
        },
        {
          label: "移动",
          options: [
            {
              value: "手机管理大师"
            },
            {
              value: "傲软投屏"
            },
            {
              value: "傲软咖玩"
            },
            {
              value: "苹果录屏王"
            },
            {
              value: "安卓录屏王"
            },
            {
              value: "苹果数据恢复"
            },
            {
              value: "iOS解锁大师"
            }
          ]
        },
        {
          label: "办公",
          options: [
            {
              value: "傲软录屏"
            },
            {
              value: "傲软PDF编辑"
            },
            {
              value: "数据恢复王"
            },
            {
              value: "专业截屏王"
            },
            {
              value: "PDF转换王"
            },
            {
              value: "录屏王"
            },
            {
              value: "傲软抠图"
            },
            {
              value: "傲软CAD看图"
            },
            {
              value: "傲软PDF压缩"
            },
            {
              value: "傲软拼图"
            }
          ]
        }
      ],
      extension_channel:[
            {
              value: "网站"
            },
            {
              value: "知乎"
            },
            {
              value: "微博"
            },
            {
              value: "微信公众"
            },
            {
              value: "抖音"
            },
            {
              value: "其它"
            }
      ],
      bank_name:'',
      bank_account:'',
      errorInput1:'',
      errorInput2:'',
      rules: {
        telephone: [{ validator: telephoneValidator, trigger: "blur" }],
        captcha: [{ required: true, message: "请输入验证码", trigger: "blur" }],
        email: [
          {
            required: true,
            type: "email",
            message: "请输入正确的邮箱地址",
            trigger: ["blur", "change"]
          }
        ]
      },
      lang: "zh-cn",
      pickerOptions0: {
        disabledDate: time => {
          if (this.end_time) {
            return time.getTime() > new Date(this.end_time).getTime();
          }
        }
      },
      pickerOptions1: {
        disabledDate: time => {
          if (this.start_time) {
            return (
              time.getTime() < new Date(this.start_time).getTime() - 86400000
            );
          }
        }
      }
    };
  },
  mounted() {
    const areaCodes = Storage.get("areacodes");
    if (areaCodes) {
      this.areaCodes = areaCodes;
      this.form.country_code = this.areaCodes[0].key;
    }
  },
  methods: {
    changeSelect(val) {
       if(val.length > this.selectLength){
        if (val.includes('全选') && val.length < 26) {
        this.form.like_product = []
        this.like_product.forEach((item,index)=>{
        item.options.map((item2) => {
        this.form.like_product.push(item2.value)
                    })
                  })
        }else if (!val.includes('全选') && val.length === 25) {
        this.form.like_product.unshift('全选')
        }
    }else{
        if (val.includes('全选') && val.length < 26) { 
            this.form.like_product = this.form.like_product.filter((item) => {
            return item !== '全选'
        })
        }else if (!val.includes('全选') && val.length === 25) {
         this.form.like_product = []
        }
     }
     this.selectLength = this.form.like_product.length
     let _this = this;
       setTimeout(function() {
        _this.$refs.selectProduct.blur();
     }, 50);
    },
      
    handleCommand(command) {
      if (command === "logout") {
        this.$store.dispatch("Logout");
      } else if (command === "profit") {
        this.mainRoute = "profit";
        this.searchIncome();
      } else if (command === "apply") {
        this.mainRoute = "apply";
      }
    },

    showAccountDialog() {
      this.$showModal(
        () => ({
        component: import(
          /* webpackPrefetch: true */
          /*  webpackChunkName: "Account" */
          `@/components/Account.vue`
          )
        }),
        {
          width: "400px",
          height: "500px",
        },
        {
          successCallback: () => {
            this.$hideModal("Account");
          }
        },
        "Account"
      );
    },

    async sendVcode() {
      if (this.phoneTimeout) {
        return;
      }
      if (!this.form.telephone || !isPhone(this.form.telephone)) {
        return;
      }
      let postData;
      const brandId = Storage.get("brandId");
      postData = {
        country_code: "+86",
        telephone: this.form.telephone,
        language: this.lang,
        brand_id: brandId,
        scene: "login"
      };

      try {
        const { status } = await captchas(postData);
        if (status === 200) {
          this.phoneTimeout = 60;
          this.phoneIntervalId = setInterval(() => {
            this.phoneTimeout -= 1;
            if (this.phoneTimeout === 0) {
              clearInterval(this.phoneIntervalId);
            }
          }, 1000);
        } else {
          this.processError(status);
        }
      } catch (error) {
        this.processError(error);
      }
    },

    submit() {
      this.$refs.applyForm.validate(valid => {
        if (valid) {
          this.loading = true;
          this.$store
            .dispatch("PasswordLessLogin", {
              country_code: "+86",
              telephone: this.form.telephone,
              captcha: this.form.captcha,
              language: this.lang
            })
            .then(() => {
              this.processSuccess();
            })
            .catch(error => {
              this.processError(error);
            })
            .finally(() => {
              this.loading = false;
            });
        }
      });
    },

    processSuccess() {
      // const user = JSON.parse(window.localStorage.getItem("userInfo") || "{}");
      // uid: user.user_id,
      var temp_like_product = '';
      if(this.form.like_product.includes('全选')){
        temp_like_product = this.form.like_product[0].toString();
      }else{
        temp_like_product = this.form.like_product.toString();
      }

      const postData = {
        name: this.form.name,
        telephone: this.form.telephone,
        email: this.form.email,
        wechat: this.form.wechat,
        company: this.form.company,
        address: this.form.address,
        how_learn: this.form.how_learn,
        like_product: temp_like_product,
        how_extend: this.form.how_extend,
        extension_channel: this.form.extension_channel,
        channel_link: this.form.channel_link,
        mark: this.form.mark
      };
      applyAgent(postData)
        .then(res => {
          this.$messageBox.alert('提交成功，等待审核中，审核结果我们会以邮箱的方式通知您！',{
           confirmButtonText: '确定',
          });
        })
        .catch(error => {
          this.processError(error);
        })
        .finally(() => {
         
        });
    },

    processError(error) {
      console.log(error);
        if (error === -307) {
            this.$messageBox.alert('抱歉，验证码发送超过每日3次!',{
            confirmButtonText: '确定',
            });
          }
        if (error === -303) {
            this.$messageBox.alert('验证码错误!',{
            confirmButtonText: '确定',
            });
        }
        if (error === -101) {
            this.$messageBox.alert('缺少参数!',{
            confirmButtonText: '确定',
            });
        }
        if (error === -404) {
            this.$messageBox.alert('用户不存在或identity_token错误!',{
            confirmButtonText: '确定',
            });
        }
        if (error.status === -401) {
            this.$messageBox.alert('您已申请过，请勿重复提交，等待审核中!',{
            confirmButtonText: '确定',
            });
          }
    },
    processCountryCode(countryCode) {
      return countryCode.split(":")[0];
    },
    getProfit() {
      const identity_token = Storage.get("identityToken");
      if (identity_token) {
        this.mainRoute = "profit";
        this.searchIncome();
      } else {
        this.showAccountDialog();
      }
    },
    searchIncome() {
      this.loading = true;
      const identity_token = Storage.get("identityToken");
      const postData = {
        identity_token: identity_token,
        page: this.page,
        limit: this.limit,
        start_time: this.start_time,
        end_time: this.end_time
      };
      getIncome(postData)
        .then(res => {
          if (res.status === 200) {
            this.list = res.data.list || [];
            this.total = res.data.total;
            this.total_amount = res.data.total_amount;
            this.share_amount = res.data.share_amount;
            this.share_amount_complete = res.data.share_amount_complete;
            this.share_amount_wait = res.data.share_amount_wait;
          }
        })
        .catch(err => {
          this.error = true;
          console.log(err);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    handleCurrentChange(newPage) {
      this.currentPage = newPage;
      this.page = newPage;
      this.searchIncome();
    },
    submitBankInfo(){
      if(this.bank_name == ''){
        this.errorInput1 = 'errorInput'
        return;
      }else if(this.bank_account == ''){
        this.errorInput2 = 'errorInput'
        return;
      }
      // const user = JSON.parse(window.localStorage.getItem("userInfo") || "{}");
      // uid: user.user_id,
      this.loading = true;
      const postData = {
        bank_name: this.bank_name,
        bank_account: this.bank_account,
      };
      updateBank(postData)
        .then(res => {
            this.$messageBox.alert('提交成功!',{
            confirmButtonText: '确定',
            });
        })
        .catch(error => {
          this.processError(error);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    nameInput(val){
      if(val){
        this.errorInput1 = ''
      }
    },
    accountInput(val){
      if(val){
        this.errorInput2 = ''
      }
    },
  },
  computed: {
    ...mapState({
      identityToken: state => state.user?.identityToken,
      userInfo: state => state.user?.userInfo
    })
  }
};
